import ServiceBlockLogos from "components/ServiceBlockLogos";

const TechStackList = () => {
  const techStackList = [
    {
      id: "generative-ai",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="72"
          height="78"
          viewBox="0 0 72 78"
          fill="none"
        >
          <rect
            y="0.000183105"
            width="72"
            height="77.0973"
            rx="9"
            fill="url(#paint0_linear_21_1082)"
          />
          <path
            d="M35.7267 64C31.2605 47.5826 25.7353 41.9244 10 38.6711C10 38.6711 20.54 37.8725 27.4533 30.7987C34.3667 23.7248 35.7267 13 35.7267 13C38.596 29.7696 44.2266 35.2921 61 38.6711C45.2588 42.5067 39.6033 47.9174 35.7267 64Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_21_1082"
              x1="57.3451"
              y1="3.18603"
              x2="40.1416"
              y2="56.071"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#AC6BFF" />
              <stop offset="1" stop-color="#8756DE" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Generative AI and ML Modeling",
      description:
        "We employ cutting-edge AI and ML tools to enhance your business processes and decision-making.",
      logos: [
        {
          id: 1,
          alt: "Langchain",
          img: require("assets/images/tech-stack/langchain.png"),
        },
        {
          id: 2,
          alt: "Pinecone",
          img: require("assets/images/tech-stack/pinecone.png"),
        },
        {
          id: 3,
          alt: "mistral",
          img: require("assets/images/tech-stack/mistral.png"),
        },
        {
          id: 4,
          alt: "Meta",
          img: require("assets/images/tech-stack/meta.png"),
        },
        {
          id: 5,
          alt: "HuggingFace",
          img: require("assets/images/tech-stack/huggingface.png"),
        },
        {
          id: 6,
          alt: "Weights and Biases",
          img: require("assets/images/tech-stack/weightsandbiases.png"),
        },
      ],
    },
    {
      id: "dashboards",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="72"
          height="78"
          viewBox="0 0 72 78"
          fill="none"
        >
          <rect
            width="72"
            height="77.0973"
            rx="9"
            fill="url(#paint0_linear_21_1127)"
          />
          <path
            d="M29.5132 35.0726C29.9365 35.0726 30.3591 35.017 30.768 34.9063C31.0239 34.8369 31.2738 34.746 31.5146 34.6353C31.4703 34.335 31.4481 34.0319 31.4481 33.7283C31.4481 32.0932 32.0919 30.5395 33.2479 29.3833C33.4939 29.1373 33.7605 28.9124 34.0442 28.7113C33.7395 27.8293 33.1842 27.057 32.4448 26.4859C31.604 25.8362 30.5755 25.4868 29.5132 25.4868C28.2375 25.4868 27.0258 25.9887 26.124 26.8905C25.222 27.7924 24.7202 29.0041 24.7202 30.2796C24.7202 31.5552 25.2224 32.7669 26.124 33.6688C27.0258 34.5708 28.2375 35.0726 29.5132 35.0726Z"
            fill="white"
          />
          <path
            d="M34.2041 37.1173C35.1059 38.0193 36.3177 38.5211 37.5933 38.5211C38.869 38.5211 40.0806 38.0193 40.9826 37.1173C41.8846 36.2155 42.3863 35.0038 42.3863 33.7282C42.3863 32.4526 41.8844 31.241 40.9826 30.339C40.0808 29.437 38.869 28.9352 37.5933 28.9352C36.3177 28.9352 35.1061 29.437 34.2041 30.339C33.3021 31.2408 32.8003 32.4526 32.8003 33.7282C32.8003 35.0039 33.3022 36.2155 34.2041 37.1173Z"
            fill="white"
          />
          <path
            d="M43.7374 33.7281C43.7374 34.0316 43.7152 34.3348 43.6709 34.6351C43.9117 34.7459 44.1616 34.8367 44.4176 34.9061C44.8263 35.0167 45.2489 35.0724 45.6722 35.0724C46.9479 35.0724 48.1595 34.5705 49.0615 33.6687C49.9633 32.7667 50.4653 31.5551 50.4653 30.2795C50.4653 29.0038 49.9634 27.7923 49.0615 26.8903C48.1597 25.9884 46.9479 25.4867 45.6722 25.4867C44.6097 25.4867 43.5812 25.8361 42.7405 26.4858C42.0013 27.0571 41.4459 27.8295 41.1411 28.7113C41.4248 28.9124 41.6916 29.1374 41.9375 29.3833C43.0936 30.5392 43.7374 32.0928 43.7374 33.728L43.7374 33.7281Z"
            fill="white"
          />
          <path
            d="M51.3575 37.8024C49.6949 36.8219 47.5836 36.4244 45.6726 36.4244C45.1618 36.4244 44.6503 36.4518 44.1425 36.5092C43.7509 36.5534 43.3609 36.6153 42.9747 36.6957C42.6955 37.2009 42.346 37.6652 41.9377 38.0732C41.627 38.3839 41.2837 38.6609 40.9146 38.8986C41.9753 39.1492 43.0275 39.5361 43.9643 40.0887C45.4646 40.9735 46.7941 42.3853 46.7941 44.225V49.1819C47.6624 49.1414 48.5328 49.0534 49.3891 48.904C50.1359 48.7738 50.8908 48.595 51.6043 48.3369C52.0902 48.1612 53.522 47.5916 53.522 46.9329V40.7762C53.522 39.452 52.4152 38.4258 51.3577 37.8023L51.3575 37.8024Z"
            fill="white"
          />
          <path
            d="M43.2779 41.2506C41.6152 40.2701 39.504 39.8728 37.5929 39.8728C35.6818 39.8728 33.5704 40.2701 31.908 41.2506C30.8504 41.8743 29.7437 42.9003 29.7437 44.2246V50.3813C29.7437 51.0705 31.2773 51.6543 31.7842 51.8296C32.6188 52.1185 33.5084 52.3056 34.3815 52.4325C35.4423 52.5862 36.5214 52.6542 37.5931 52.6542C38.6648 52.6542 39.7439 52.5862 40.8047 52.4325C41.6778 52.3056 42.5674 52.1183 43.402 51.8296C43.9089 51.6542 45.4425 51.0704 45.4425 50.3813V44.2246C45.4425 42.9004 44.3358 41.8742 43.2782 41.2506H43.2779Z"
            fill="white"
          />
          <path
            d="M31.2211 40.0885C32.158 39.536 33.21 39.1491 34.271 38.8985C33.9018 38.6608 33.5584 38.384 33.2477 38.0731C32.8397 37.6651 32.49 37.2008 32.2108 36.6956C31.8247 36.6151 31.4347 36.5533 31.0429 36.5091C30.5353 36.4517 30.0239 36.4243 29.513 36.4243C27.6018 36.4243 25.4905 36.8218 23.828 37.8023C22.7705 38.4258 21.6636 39.4519 21.6636 40.7762V46.9329C21.6636 47.5917 23.0954 48.1612 23.5813 48.3368C24.2948 48.5949 25.0496 48.7737 25.7963 48.904C26.6526 49.0533 27.523 49.1412 28.3915 49.1818V44.2249C28.3916 42.3852 29.7209 40.9733 31.2212 40.0886L31.2211 40.0885Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_21_1127"
              x1="63.7627"
              y1="5.39632e-06"
              x2="30.9532"
              y2="32.7786"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7475FF" />
              <stop offset="1" stop-color="#6163F6" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Dashboards",
      description:
        "We leverage powerful dashboard tools to provide you with clear and actionable insights.",
      logos: [
        {
          id: 1,
          alt: "tableau",
          img: require("assets/images/tech-stack/tableau.png"),
        },
        {
          id: 2,
          alt: "Snowflake",
          img: require("assets/images/tech-stack/snowflake.png"),
        },
        {
          id: 3,
          alt: "domo",
          img: require("assets/images/tech-stack/domo.png"),
        },
        {
          id: 4,
          alt: "IBM Watson X",
          img: require("assets/images/tech-stack/watsonx.png"),
        },
        {
          id: 5,
          alt: "Sisense",
          img: require("assets/images/tech-stack/sisense.png"),
        },
        {
          id: 6,
          alt: "MSFT Power BI",
          img: require("assets/images/tech-stack/power-bi.png"),
        },
      ],
    },
    {
      id: "human-capital-management",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="75"
          height="81"
          viewBox="0 0 75 81"
          fill="none"
        >
          <rect
            width="75"
            height="81"
            rx="9"
            fill="url(#paint0_linear_21_828)"
          />
          <path
            d="M30.6848 36.8481C31.1295 36.8481 31.5735 36.7897 32.0031 36.6734C32.272 36.6004 32.5345 36.505 32.7875 36.3887C32.7409 36.0732 32.7177 35.7547 32.7177 35.4358C32.7177 33.7179 33.394 32.0855 34.6085 30.8708C34.867 30.6124 35.147 30.3761 35.4452 30.1648C35.125 29.2382 34.5416 28.4268 33.7648 27.8267C32.8814 27.1442 31.8008 26.7771 30.6848 26.7771C29.3445 26.7771 28.0715 27.3044 27.124 28.2518C26.1764 29.1994 25.6492 30.4724 25.6492 31.8125C25.6492 33.1527 26.1768 34.4257 27.124 35.3733C28.0715 36.3209 29.3445 36.8481 30.6848 36.8481Z"
            fill="white"
          />
          <path
            d="M35.6128 38.9962C36.5603 39.9439 37.8334 40.4711 39.1735 40.4711C40.5139 40.4711 41.7868 39.9438 42.7344 38.9962C43.6821 38.0488 44.2091 36.7757 44.2091 35.4355C44.2091 34.0953 43.6819 32.8224 42.7344 31.8748C41.787 30.9271 40.5139 30.3999 39.1735 30.3999C37.8334 30.3999 36.5604 30.9272 35.6128 31.8748C34.6652 32.8222 34.1379 34.0953 34.1379 35.4355C34.1379 36.7758 34.6652 38.0488 35.6128 38.9962Z"
            fill="white"
          />
          <path
            d="M45.6293 35.4354C45.6293 35.7543 45.606 36.0728 45.5594 36.3883C45.8124 36.5047 46.075 36.6002 46.3439 36.673C46.7733 36.7893 47.2173 36.8477 47.662 36.8477C49.0023 36.8477 50.2753 36.3205 51.2229 35.373C52.1704 34.4254 52.6978 33.1525 52.6978 31.8123C52.6978 30.472 52.1705 29.1992 51.2229 28.2516C50.2755 27.3039 49.0023 26.7769 47.662 26.7769C46.5458 26.7769 45.4652 27.1439 44.582 27.8265C43.8053 28.4267 43.2218 29.2382 42.9016 30.1647C43.1996 30.376 43.48 30.6123 43.7383 30.8707C44.9529 32.0851 45.6293 33.7173 45.6293 35.4353L45.6293 35.4354Z"
            fill="white"
          />
          <path
            d="M53.6352 39.7158C51.8884 38.6856 49.6702 38.2681 47.6625 38.2681C47.1258 38.2681 46.5884 38.2968 46.0549 38.3571C45.6435 38.4036 45.2337 38.4686 44.828 38.5531C44.5347 39.0838 44.1675 39.5717 43.7385 40.0003C43.4121 40.3268 43.0514 40.6177 42.6636 40.8675C43.7781 41.1308 44.8835 41.5372 45.8677 42.1178C47.444 43.0474 48.8407 44.5307 48.8407 46.4635V51.6713C49.753 51.6288 50.6675 51.5363 51.5671 51.3794C52.3517 51.2425 53.1448 51.0547 53.8944 50.7835C54.405 50.599 55.9092 50.0005 55.9092 49.3085V42.8401C55.9092 41.4489 54.7464 40.3708 53.6353 39.7157L53.6352 39.7158Z"
            fill="white"
          />
          <path
            d="M45.1461 43.3386C43.3993 42.3085 41.1812 41.8911 39.1733 41.8911C37.1655 41.8911 34.9472 42.3085 33.2006 43.3386C32.0896 43.9939 30.9268 45.0718 30.9268 46.4632V52.9316C30.9268 53.6556 32.538 54.269 33.0706 54.4532C33.9474 54.7566 34.8821 54.9532 35.7994 55.0865C36.9139 55.2481 38.0476 55.3195 39.1735 55.3195C40.2995 55.3195 41.4332 55.2481 42.5477 55.0865C43.465 54.9532 44.3996 54.7565 45.2765 54.4532C45.809 54.2689 47.4203 53.6556 47.4203 52.9316V46.4632C47.4203 45.072 46.2575 43.9938 45.1465 43.3386H45.1461Z"
            fill="white"
          />
          <path
            d="M32.4793 42.1178C33.4636 41.5372 34.5689 41.1308 35.6836 40.8675C35.2958 40.6177 34.9349 40.3269 34.6085 40.0003C34.1798 39.5717 33.8125 39.0838 33.5191 38.5531C33.1135 38.4686 32.7037 38.4036 32.2921 38.3571C31.7588 38.2968 31.2215 38.2681 30.6847 38.2681C28.6769 38.2681 26.4586 38.6856 24.712 39.7158C23.601 40.3708 22.438 41.4489 22.438 42.8402V49.3086C22.438 50.0007 23.9422 50.5991 24.4527 50.7836C25.2024 51.0547 25.9954 51.2426 26.7799 51.3795C27.6795 51.5364 28.594 51.6287 29.5065 51.6714V46.4636C29.5066 44.5307 30.9032 43.0474 32.4795 42.1178L32.4793 42.1178Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_21_828"
              x1="65.708"
              y1="-5.54455e-07"
              x2="37.0673"
              y2="80.8467"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#67E5FF" />
              <stop offset="1" stop-color="#3EC4E0" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Human Capital Management",
      description:
        "Our HCM solutions streamline your HR processes and improve employee management.",
      logos: [
        {
          id: 1,
          alt: "Workday",
          img: require("assets/images/tech-stack/workday.png"),
        },
        {
          id: 2,
          alt: "Dayforce",
          img: require("assets/images/tech-stack/dayforce.png"),
        },
        {
          id: 3,
          alt: "ADP",
          img: require("assets/images/tech-stack/adp.png"),
        },
        {
          id: 4,
          alt: "OracleHR",
          img: require("assets/images/tech-stack/OracleHR.png"),
        },
        {
          id: 5,
          alt: "UKG",
          img: require("assets/images/tech-stack/ukg.jpg"),
        },
        {
          id: 6,
          alt: "HRone",
          img: require("assets/images/tech-stack/hrone-logo.png"),
        },
      ],
    },
    {
      id: "financial-planning",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="75"
          height="81"
          viewBox="0 0 75 81"
          fill="none"
        >
          <rect
            width="75"
            height="81"
            rx="9"
            fill="url(#paint0_linear_21_1152)"
          />
          <rect
            width="75"
            height="81"
            rx="9"
            fill="url(#paint1_linear_21_1152)"
          />
          <path
            d="M30.6845 36.8481C31.1293 36.8481 31.5732 36.7897 32.0028 36.6734C32.2717 36.6004 32.5343 36.505 32.7873 36.3887C32.7407 36.0732 32.7174 35.7547 32.7174 35.4358C32.7174 33.7179 33.3937 32.0855 34.6083 30.8708C34.8667 30.6124 35.1468 30.3761 35.4449 30.1648C35.1247 29.2382 34.5414 28.4268 33.7646 27.8267C32.8812 27.1442 31.8006 26.7771 30.6845 26.7771C29.3442 26.7771 28.0713 27.3044 27.1238 28.2518C26.1761 29.1994 25.6489 30.4724 25.6489 31.8125C25.6489 33.1527 26.1765 34.4257 27.1238 35.3733C28.0713 36.3209 29.3442 36.8481 30.6845 36.8481Z"
            fill="white"
          />
          <path
            d="M35.613 38.9962C36.5605 39.9439 37.8336 40.4711 39.1738 40.4711C40.5141 40.4711 41.7871 39.9438 42.7347 38.9962C43.6823 38.0488 44.2094 36.7757 44.2094 35.4355C44.2094 34.0953 43.6821 32.8224 42.7347 31.8748C41.7873 30.9271 40.5141 30.3999 39.1738 30.3999C37.8336 30.3999 36.5607 30.9272 35.613 31.8748C34.6654 32.8222 34.1382 34.0953 34.1382 35.4355C34.1382 36.7758 34.6654 38.0488 35.613 38.9962Z"
            fill="white"
          />
          <path
            d="M45.6291 35.4354C45.6291 35.7543 45.6058 36.0728 45.5592 36.3883C45.8122 36.5047 46.0747 36.6002 46.3437 36.673C46.7731 36.7893 47.217 36.8477 47.6618 36.8477C49.0021 36.8477 50.275 36.3205 51.2227 35.373C52.1702 34.4254 52.6975 33.1525 52.6975 31.8123C52.6975 30.472 52.1703 29.1992 51.2227 28.2516C50.2752 27.3039 49.0021 26.7769 47.6618 26.7769C46.5456 26.7769 45.465 27.1439 44.5817 27.8265C43.8051 28.4267 43.2216 29.2382 42.9014 30.1647C43.1994 30.376 43.4797 30.6123 43.738 30.8707C44.9527 32.0851 45.6291 33.7173 45.6291 35.4353L45.6291 35.4354Z"
            fill="white"
          />
          <path
            d="M53.6352 39.7158C51.8884 38.6856 49.6702 38.2681 47.6625 38.2681C47.1258 38.2681 46.5884 38.2968 46.0549 38.3571C45.6435 38.4036 45.2337 38.4686 44.828 38.5531C44.5347 39.0838 44.1675 39.5717 43.7385 40.0003C43.4121 40.3268 43.0514 40.6177 42.6636 40.8675C43.7781 41.1308 44.8835 41.5372 45.8677 42.1178C47.444 43.0474 48.8407 44.5307 48.8407 46.4635V51.6713C49.753 51.6288 50.6675 51.5363 51.5671 51.3794C52.3517 51.2425 53.1448 51.0547 53.8944 50.7835C54.405 50.599 55.9092 50.0005 55.9092 49.3085V42.8401C55.9092 41.4489 54.7464 40.3708 53.6353 39.7157L53.6352 39.7158Z"
            fill="white"
          />
          <path
            d="M45.1461 43.3386C43.3993 42.3085 41.1812 41.8911 39.1733 41.8911C37.1655 41.8911 34.9472 42.3085 33.2006 43.3386C32.0896 43.9939 30.9268 45.0718 30.9268 46.4632V52.9316C30.9268 53.6556 32.538 54.269 33.0706 54.4532C33.9474 54.7566 34.8821 54.9532 35.7994 55.0865C36.9139 55.2481 38.0476 55.3195 39.1735 55.3195C40.2995 55.3195 41.4332 55.2481 42.5477 55.0865C43.465 54.9532 44.3996 54.7565 45.2765 54.4532C45.809 54.2689 47.4203 53.6556 47.4203 52.9316V46.4632C47.4203 45.072 46.2575 43.9938 45.1465 43.3386H45.1461Z"
            fill="white"
          />
          <path
            d="M32.4793 42.1178C33.4636 41.5372 34.5689 41.1308 35.6836 40.8675C35.2958 40.6177 34.9349 40.3269 34.6085 40.0003C34.1798 39.5717 33.8125 39.0838 33.5191 38.5531C33.1135 38.4686 32.7037 38.4036 32.2921 38.3571C31.7588 38.2968 31.2215 38.2681 30.6847 38.2681C28.6769 38.2681 26.4586 38.6856 24.712 39.7158C23.601 40.3708 22.438 41.4489 22.438 42.8402V49.3086C22.438 50.0007 23.9422 50.5991 24.4527 50.7836C25.2024 51.0547 25.9954 51.2426 26.7799 51.3795C27.6795 51.5364 28.594 51.6287 29.5065 51.6714V46.4636C29.5066 44.5307 30.9032 43.0474 32.4795 42.1178L32.4793 42.1178Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_21_1152"
              x1="60.3982"
              y1="-6.35386e-07"
              x2="37.1349"
              y2="80.895"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5EEACB" />
              <stop offset="1" stop-color="#33BD9E" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_21_1152"
              x1="66.4195"
              y1="5.66948e-06"
              x2="31.9508"
              y2="34.1429"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A1FDE9" />
              <stop offset="1" stop-color="#80E0D8" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Finance and FP&A",
      description:
        "We use modern FP&A tooling and cloud finance to enhance your financial planning and analysis capabilities.",
      logos: [
        {
          id: 1,
          alt: "Mosaic",
          img: require("assets/images/tech-stack/mosaic.png"),
        },
        {
          id: 2,
          alt: "Netsuite",
          img: require("assets/images/tech-stack/netsuite.png"),
        },
        {
          id: 3,
          alt: "Datarails",
          img: require("assets/images/tech-stack/datarails.png"),
        },
        {
          id: 4,
          alt: "Runway",
          img: require("assets/images/tech-stack/runway.png"),
        },
        {
          id: 5,
          alt: "ModelOptic",
          img: require("assets/images/tech-stack/modeloptic.png"),
        },
        {
          id: 6,
          alt: "DrivePoint",
          img: require("assets/images/tech-stack/drivepoint.png"),
        },
      ],
    },
    {
      id: "security",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="75"
          height="80"
          viewBox="0 0 75 80"
          fill="none"
        >
          <rect
            width="75"
            height="80"
            rx="9"
            fill="url(#paint0_linear_60_349)"
          />
          <path
            d="M28.1448 36.393C28.5841 36.393 29.0226 36.3352 29.4468 36.2204C29.7124 36.1483 29.9717 36.054 30.2216 35.9392C30.1756 35.6276 30.1526 35.313 30.1526 34.9981C30.1526 33.3014 30.8206 31.6892 32.0201 30.4895C32.2754 30.2342 32.552 30.0008 32.8465 29.7922C32.5302 28.877 31.9541 28.0756 31.1868 27.483C30.3144 26.8088 29.2471 26.4463 28.1448 26.4463C26.821 26.4463 25.5638 26.967 24.628 27.9028C23.6921 28.8387 23.1714 30.0959 23.1714 31.4196C23.1714 32.7432 23.6925 34.0004 24.628 34.9363C25.5638 35.8723 26.8211 36.393 28.1448 36.393Z"
            fill="white"
          />
          <path
            d="M33.0123 38.5146C33.9481 39.4506 35.2055 39.9713 36.5291 39.9713C37.8529 39.9713 39.1101 39.4505 40.046 38.5146C40.982 37.5789 41.5025 36.3215 41.5025 34.9978C41.5025 33.6742 40.9818 32.417 40.046 31.4811C39.1103 30.5451 37.8529 30.0244 36.5291 30.0244C35.2055 30.0244 33.9482 30.5452 33.0123 31.4811C32.0764 32.4168 31.5557 33.6742 31.5557 34.9978C31.5557 36.3216 32.0764 37.5789 33.0123 38.5146Z"
            fill="white"
          />
          <path
            d="M42.905 34.9979C42.905 35.3129 42.882 35.6275 42.836 35.9391C43.0858 36.0541 43.3451 36.1484 43.6107 36.2203C44.0348 36.3351 44.4733 36.3928 44.9126 36.3928C46.2363 36.3928 47.4936 35.8721 48.4295 34.9363C49.3653 34.0004 49.8862 32.7432 49.8862 31.4196C49.8862 30.0958 49.3654 28.8387 48.4295 27.9028C47.4937 26.9668 46.2363 26.4463 44.9126 26.4463C43.8101 26.4463 42.7429 26.8088 41.8706 27.483C41.1035 28.0758 40.5272 28.8773 40.2109 29.7923C40.5053 30.001 40.7821 30.2344 41.0373 30.4896C42.2369 31.689 42.9049 33.3011 42.9049 34.9978L42.905 34.9979Z"
            fill="white"
          />
          <path
            d="M50.8117 39.2257C49.0865 38.2083 46.8957 37.7959 44.9127 37.7959C44.3828 37.7959 43.852 37.8243 43.325 37.8839C42.9187 37.9297 42.514 37.9939 42.1133 38.0774C41.8236 38.6016 41.4609 39.0834 41.0373 39.5068C40.7149 39.8292 40.3586 40.1166 39.9756 40.3632C41.0763 40.6233 42.1681 41.0247 43.1402 41.5981C44.697 42.5162 46.0765 43.9812 46.0765 45.8901V51.0337C46.9775 50.9917 47.8807 50.9003 48.7692 50.7454C49.5441 50.6102 50.3274 50.4246 51.0678 50.1568C51.572 49.9746 53.0577 49.3835 53.0577 48.7V42.3115C53.0577 40.9375 51.9093 39.8726 50.8119 39.2256L50.8117 39.2257Z"
            fill="white"
          />
          <path
            d="M42.4275 42.8037C40.7023 41.7863 38.5117 41.374 36.5286 41.374C34.5455 41.374 32.3546 41.7863 30.6296 42.8037C29.5323 43.4508 28.3838 44.5155 28.3838 45.8897V52.2782C28.3838 52.9933 29.9752 53.5991 30.5012 53.781C31.3672 54.0807 32.2903 54.2749 33.1963 54.4065C34.297 54.5661 35.4167 54.6367 36.5288 54.6367C37.6408 54.6367 38.7605 54.5661 39.8613 54.4065C40.7673 54.2749 41.6903 54.0806 42.5563 53.781C43.0823 53.599 44.6737 52.9932 44.6737 52.2782V45.8897C44.6737 44.5156 43.5253 43.4508 42.4279 42.8037H42.4275Z"
            fill="white"
          />
          <path
            d="M29.9174 41.5978C30.8895 41.0244 31.9812 40.623 33.0821 40.363C32.699 40.1163 32.3426 39.8291 32.0202 39.5065C31.5969 39.0832 31.2341 38.6013 30.9444 38.0772C30.5437 37.9937 30.139 37.9295 29.7325 37.8836C29.2057 37.8241 28.6751 37.7957 28.1449 37.7957C26.1618 37.7957 23.971 38.2081 22.246 39.2255C21.1486 39.8725 20 40.9372 20 42.3114V48.6999C20 49.3834 21.4857 49.9744 21.9899 50.1567C22.7302 50.4245 23.5135 50.61 24.2883 50.7452C25.1768 50.9001 26.0801 50.9914 26.9812 51.0335V45.89C26.9814 43.981 28.3607 42.5159 29.9175 41.5979L29.9174 41.5978Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_60_349"
              x1="60.3982"
              y1="-6.27542e-07"
              x2="37.6631"
              y2="80.0463"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5EEACB" />
              <stop offset="1" stop-color="#33BD9E" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Security",
      description:
        "We simplify security maintenance by integrating employee lifecycle management with security tools.",
      logos: [
        {
          id: 1,
          alt: "CrowdStrike",
          img: require("assets/images/tech-stack/crowdstrike.png"),
        },
        {
          id: 2,
          alt: "JumpCloud",
          img: require("assets/images/tech-stack/jumpcloud.png"),
        },
        {
          id: 3,
          alt: "fortinet",
          img: require("assets/images/tech-stack/fortinet.png"),
        },
        {
          id: 4,
          alt: "AzureDefender",
          img: require("assets/images/tech-stack/azuredefender.png"),
        },
        {
          id: 5,
          alt: "Jamf",
          img: require("assets/images/tech-stack/jamf.png"),
        },
        {
          id: 6,
          alt: "Intune",
          img: require("assets/images/tech-stack/intune.png"),
        },
      ],
    },
    {
      id: "integration",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="75"
          height="80"
          viewBox="0 0 75 80"
          fill="none"
        >
          <rect
            width="75"
            height="80"
            rx="9"
            fill="url(#paint0_linear_21_1181)"
          />
          <path
            d="M57.5367 36.1155C55.9537 36.1155 54.6672 37.1308 54.2221 38.533H46.9V34.4717V34.3265H51.0064C51.5505 34.3265 52.0453 33.8914 52.0453 33.3113V28.9115C53.4801 28.4763 54.519 27.2192 54.519 25.6722C54.519 23.7865 52.9853 22.2877 51.0558 22.2877C49.1263 22.2877 47.5926 23.7865 47.5926 25.6722C47.5926 27.2192 48.6315 28.4765 50.0663 28.9115V32.3442H46.3558C45.6137 31.1355 44.278 30.3136 42.7441 30.3136H38.5883V25.6238C40.0231 25.1886 41.062 23.9315 41.062 22.3844C41.062 20.4988 39.5284 19 37.5988 19C35.6693 19 34.1357 20.4988 34.1357 22.3844C34.1357 23.9315 35.1746 25.1888 36.6094 25.6238V30.3136H32.4536C30.9199 30.3136 29.584 31.1355 28.8419 32.3442H25.1314V28.9115C26.5661 28.4763 27.6051 27.2192 27.6051 25.6722C27.6051 23.7865 26.0714 22.2877 24.1419 22.2877C22.2124 22.2877 20.6787 23.7865 20.6787 25.6722C20.6787 27.2192 21.7176 28.4765 23.1524 28.9115V33.3113C23.1524 33.8431 23.5977 34.3265 24.1913 34.3265L28.1 34.3267V34.4718V38.5332L20.7778 38.533C20.3325 37.1308 19.0462 36.1155 17.4632 36.1155C15.5336 36.1155 14 37.6143 14 39.5C14 41.3856 15.5336 42.8844 17.4632 42.8844C19.0462 42.8844 20.3327 41.8691 20.7778 40.467H28.1V44.5283V44.6734H23.9935C23.4494 44.6734 22.9546 45.1086 22.9546 45.6887V50.1368C21.5199 50.572 20.4809 51.8291 20.4809 53.3762C20.4809 55.2618 22.0146 56.7606 23.9441 56.7606C25.8736 56.7606 27.4073 55.2618 27.4073 53.3762C27.4073 51.8291 26.3684 50.5718 24.9336 50.1368V46.6558H28.6441C29.3862 47.8645 30.7219 48.6864 32.2558 48.6864H36.5105V53.3762C35.0758 53.8114 34.0369 55.0685 34.0369 56.6156C34.0369 58.5012 35.5705 60 37.5 60C39.4295 60 40.9632 58.5012 40.9632 56.6156C40.9632 55.0685 39.9243 53.8112 38.4895 53.3762V48.6864H42.6453C44.1789 48.6864 45.5149 47.8645 46.257 46.6558H49.9675L49.9673 50.1368C48.5326 50.572 47.4936 51.8291 47.4936 53.3762C47.4936 55.2618 49.0273 56.7606 50.9568 56.7606C52.8863 56.7606 54.42 55.2618 54.42 53.3762C54.42 51.8291 53.3811 50.5718 51.9463 50.1368V45.6887C51.9463 45.1569 51.501 44.6734 50.9074 44.6734L46.9 44.6733V44.5281V40.4668H54.2222C54.6675 41.869 55.9538 42.8843 57.5368 42.8843C59.4664 42.8843 61 41.3855 61 39.4998C61 37.6142 59.4664 36.1154 57.5368 36.1154L57.5367 36.1155ZM49.5715 25.6721C49.5715 24.8986 50.2147 24.2699 51.0062 24.2699C51.7978 24.2699 52.441 24.8986 52.441 25.6721C52.441 26.4456 51.7978 27.0743 51.0062 27.0743C50.2145 27.0743 49.5715 26.4456 49.5715 25.6721ZM22.5588 25.6721C22.5588 24.8986 23.202 24.2699 23.9935 24.2699C24.7851 24.2699 25.4283 24.8986 25.4283 25.6721C25.4283 26.4456 24.7851 27.0743 23.9935 27.0743C23.2018 27.0743 22.5588 26.4456 22.5588 25.6721ZM17.463 40.9021C16.6714 40.9021 16.0282 40.2735 16.0282 39.4999C16.0282 38.7264 16.6714 38.0978 17.463 38.0978C18.2545 38.0978 18.8977 38.7264 18.8977 39.4999C18.8977 40.2735 18.2545 40.9021 17.463 40.9021ZM25.4282 53.3762C25.4282 54.1498 24.785 54.7784 23.9935 54.7784C23.2019 54.7784 22.5587 54.1498 22.5587 53.3762C22.5587 52.6027 23.2019 51.974 23.9935 51.974C24.7852 51.9742 25.4282 52.6027 25.4282 53.3762ZM36.0651 22.3843C36.0651 21.6108 36.7084 20.9822 37.4999 20.9822C38.2914 20.9822 38.9347 21.6108 38.9347 22.3843C38.9347 23.1579 38.2914 23.7865 37.4999 23.7865C36.7084 23.7865 36.0651 23.1579 36.0651 22.3843ZM38.9347 56.6156C38.9347 57.3892 38.2914 58.0178 37.4999 58.0178C36.7084 58.0178 36.0651 57.3892 36.0651 56.6156C36.0651 55.8421 36.7084 55.2134 37.4999 55.2134C38.2914 55.2134 38.9347 55.8421 38.9347 56.6156ZM41.9031 37.9528L37.3515 42.6427C37.1041 42.8844 36.8073 43.0295 36.4609 43.0295C36.1147 43.0295 35.8177 42.8844 35.5703 42.6427L33.0966 40.0801C32.6513 39.5966 32.6513 38.8714 33.146 38.3879C33.6408 37.9527 34.3829 37.9527 34.8776 38.4362L36.4607 40.0801L40.1218 36.3088C40.5671 35.8253 41.3587 35.8253 41.8534 36.2605C42.3483 36.7441 42.3483 37.5177 41.903 37.9528L41.9031 37.9528ZM52.441 53.3762C52.441 54.1498 51.7978 54.7784 51.0062 54.7784C50.2147 54.7784 49.5715 54.1498 49.5715 53.3762C49.5715 52.6027 50.2147 51.974 51.0062 51.974C51.798 51.9742 52.441 52.6027 52.441 53.3762ZM57.5368 40.9021C56.7453 40.9021 56.1021 40.2735 56.1021 39.4999C56.1021 38.7264 56.7453 38.0978 57.5368 38.0978C58.3284 38.0978 58.9716 38.7264 58.9716 39.4999C58.9716 40.2735 58.3284 40.9021 57.5368 40.9021Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_21_1181"
              x1="59.7345"
              y1="3.30579"
              x2="41.939"
              y2="58.2223"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#AC6BFF" />
              <stop offset="1" stop-color="#8756DE" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Integration",
      description:
        "Our integration services ensure all your systems work together seamlessly.",
      logos: [
        {
          id: 1,
          alt: "Servicenow",
          img: require("assets/images/tech-stack/servicenow.png"),
        },
        {
          id: 2,
          alt: "Zapier",
          img: require("assets/images/tech-stack/zapier.png"),
        },
        {
          id: 3,
          alt: "MuleSoft",
          img: require("assets/images/tech-stack/mulesoft.png"),
        },
        {
          id: 4,
          alt: "Workato",
          img: require("assets/images/tech-stack/workato.png"),
        },
        {
          id: 5,
          alt: "Boomi",
          img: require("assets/images/tech-stack/boomi.png"),
        },
        {
          id: 6,
          alt: "Pentaho",
          img: require("assets/images/tech-stack/pentaho.png"),
        },
      ],
    },
  ];
  return (
    <div className="mx-auto mb-12 max-w-7xl">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {techStackList.map((item) => (
          <div
            id={item.id}
            key={item.id}
            className="rounded-lg bg-white p-6 shadow-md"
          >
            <div className="mb-4 flex items-center">
              <div className="mr-4 flex-shrink-0">{item.icon}</div>
              <h4 className="text-xl !font-bold">{item.title}</h4>
            </div>
            <p className="text-md my-7">{item.description}</p>
            <div className="grid grid-cols-2 items-center justify-center gap-x-6 gap-y-7">
              {item.logos.map((logo) => (
                <img
                  key={logo.id}
                  src={logo.img}
                  alt={logo.alt}
                  className="max-h-12 w-full object-contain"
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechStackList;
